import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import myRestClient from "../common/restClient";
import TranslatedText from "./TranslatedText";

export default class ForceProvisioningSucceeded extends Component {
    state = { can_force_provisioning: false, error: false };

    componentDidMount() {
        this.setState({
            can_force_provisioning: this.props.can_force_provisioning
        });
    }
    force = () => {
        const { resource_id } = this.props;
        const body = {
            id: resource_id,
            data: {
                action: "force_provisioning_succeeded"
            },
            previousData: {
                password: null
            }
        };
        myRestClient("UPDATE", "installations", body).then(
            () => {
                this.setState({
                    showSnackBar: true,
                    error: false,

                    can_force_provisioning: false
                });
                window.location.reload();
            },
            () => {
                this.setState({ showSnackBar: true, error: true });
            }
        );
    };

    renderSnackBar() {
        return (
            <Snackbar
                open={this.state.showSnackBar}
                autoHideDuration={6000}
                message={this.renderSnackMessage()}
                onClose={_ =>
                    this.setState({
                        error: false,
                        showSnackBar: false
                    })
                }
            />
        );
    }

    renderSnackMessage() {
        return this.state.error === false ? (
            <span id="snack-message">
                <TranslatedText
                    resource_name={`resources.installations.actions.forcedProvisioningSucceeded`}
                />
            </span>
        ) : (
            <span id="snack-message">
                <TranslatedText
                    resource_name={`resources.installations.actions.forceSucceededFailed`}
                />
            </span>
        );
    }

    render() {
        return (
            <span>
                {this.state.can_force_provisioning ? (
                    <Button
                        color="primary"
                        target="_blank"
                        onClick={this.force}
                    >
                        <TranslatedText
                            resource_name={`resources.installations.actions.forceSucceeded`}
                        />
                    </Button>
                ) : null}

                {this.renderSnackBar()}
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ForceProvisioningSucceeded.js